module.exports = __webpack_public_path__ + "static/community-2-758f1a1a43166b896bf5eed4c68e4fca.png";